<!-- 兑换记录 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="top">
        <el-row :gutter="20" style="width:100%">
          <!-- <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-date-picker
                v-model="data"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </el-col> -->
          <el-col :span="6">
            <div class="flex">
              <el-input
                placeholder="请输入手机号"
                v-model="mobile"
                clearable
                size="small"
              ></el-input>
              <el-button type="primary" size="small" @click="getList(1)"
                >搜索</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="cont">
        <div class="table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column label="用户">
              <template slot-scope="scope">{{
                scope.row.user.username
              }}</template>
            </el-table-column>
            <el-table-column label="奖项名称">
              <template slot-scope="scope">{{
                scope.row.product.item_name
              }}</template>
            </el-table-column>
            <el-table-column prop="products" label="等级">
              <template slot-scope="scope">{{
                scope.row.product.level
              }}</template>
            </el-table-column>
            <el-table-column prop="products" label="奖品">
              <template slot-scope="scope">
                <span v-if="scope.row.product.type == 0">
                  积分{{ scope.row.product.amount }}
                </span>
                <span v-if="scope.row.product.type == 1">
                  余额{{ scope.row.product.amount }}元
                </span>
                <div v-if="scope.row.product.type == 2">
                  <span
                    v-for="(cou, idx) in scope.row.product.coupon"
                    :key="idx"
                    >{{ cou.title }}</span
                  >
                </div>
                <span v-if="scope.row.product.type == 3">
                  物品{{ scope.row.product.item_name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <!-- <span v-if="scope.row.product.type == 0">
                  赠送积分
                </span>
                <span v-if="scope.row.product.type == 1">
                  赠送余额
                </span>
                <div v-if="scope.row.product.type == 2">
                  赠送
                  <span
                    v-for="(cou, idx) in scope.row.product.coupon"
                    :key="idx"
                    >{{ cou.title }}</span
                  >
                </div> -->
                <div v-if="scope.row.product.type != 3">
                  <el-tag type="danger">
                    中奖了
                  </el-tag>
                </div>
                <div
                  v-if="scope.row.product.type == 3"
                  style="cursor: pointer;"
                >
                  <el-tag v-if="scope.row.deal_status == 1" type="danger">
                    已核销
                  </el-tag>
                  <el-tag
                    v-if="scope.row.deal_status == 0"
                    type="success"
                    @click="option(scope.row.id)"
                  >
                    未核销
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="抽奖时间"
            ></el-table-column>
          </el-table>
          <el-pagination
            :page-size="10"
            layout="prev, pager, next"
            :total="total"
            @current-change="getPageData"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { my_awardList, my_awardAuth } from "@/api/drawAward";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["app_id", "token", "merch_id"])
  },
  data() {
    return {
      tableData: [],
      mobile: "",
      data: [],
      showDialog: false,
      page: 0,
      formData: {},
      total: 0
    };
  },

  mounted() {
    this.getList(1);
  },
  methods: {
    option(Oid) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        id: Oid
      };
      this.$confirm("确定要核销吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          my_awardAuth(data).then(res => {
            if (res.code == 200) {
              this.$message.success("核销成功！！");
              this.getList(1);
            } else {
              this.$message.warning(res.msg);
            }
          });
        })
        .catch();
    },
    getPageData(val) {
      this.getList(val);
    },
    async getList(page) {
      try {
        let data = {
          token: this.token,
          app_id: this.app_id,
          merch_id: 0,
          page: page,
          store_id: 0, //
          mobile: this.mobile
        };
        const res = await my_awardList(data);
        if (res.code == 200) {
          this.total = res.data.total_num;
          res.data.result.map(item => {
            if (!item.product) {
              item.product = {};
            }
          });
          this.tableData = res.data.result;
        }
      } catch (error) {}
    },
    pop(status, index) {
      if (status == 1) {
        this.$message("已经完成核销！");
      } else {
        this.$prompt("请输入核销码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消"
        })
          .then(({ value }) => {
            console.log("填的值", value);
            let data = {
              token: this.token,
              app_id: this.app_id,
              id: index,
              cancel_code: value
            };
            orderVerifiy(data).then(res => {
              console.log("核销订单", res);
              if (res == 200) {
                this.$message({
                  type: "success",
                  message: msg
                });
              } else {
                this.$message({
                  type: "info",
                  message: "核销码错误"
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入"
            });
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../public/style/_interfacePublic";
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content {
  width: 100%;
  .bodycontent {
    height: 100%;
    .top {
      height: 80px;
      padding: 20px 0;
    }
    .cont {
      height: calc(100% - 80px);
      .table {
        border: 1px solid #eeeeee;
        .title {
          height: 60px;
          line-height: 60px;
          background: #f5f7fa;
        }
        .list {
          padding: 20px 0 20px;
          .box {
            border: 1px solid #f1f1f1;
            .bianhao {
              height: 40px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: #f5f7fa;
            }
            .detail {
            }
          }
        }
      }
    }
  }
}
</style>
